const SRC = "https://checkout.razorpay.com/v1/checkout.js";

export const loadRazorpay = () => new Promise((resolve, reject) => {
  if (window.Razorpay) return resolve();
  const s = document.createElement("script");
  s.src = SRC;
  s.onload = () => resolve();
  s.onerror = () => reject(new Error("Could not load Razorpay. Check your connection."));
  document.body.appendChild(s);
});
